import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { CommonService } from 'src/app/services/common/common.service';
import { CustomValidators } from 'src/app/constants/validation.constants';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastService } from '../toast-notification/toast.service';

@Component({
  selector: 'aog-web-access-popup',
  templateUrl: './web-access-popup.component.html',
  styleUrls: ['./web-access-popup.component.scss']
})
export class WebAccessPopupComponent implements OnInit {
  secretPassword: string;
  webAccessForm: FormGroup;
  userName: string;
  constructor(
    private $fb: FormBuilder,
    private $common: CommonService,
    private $toast: ToastService,
    public $dialogRef: MatDialogRef<WebAccessPopupComponent>
  ) {
    this.createForm();
    this.secretPassword = this.$common.secretKeyText;
    this.userName = this.$common.siteUserName;
  }

  createForm() {
    this.webAccessForm = this.$fb.group({
      userName: ['', CustomValidators.name],
      password: ['', CustomValidators.passwordNoValidation]
    })
  }

  ngOnInit() {
  }

  async onSubmit() {
    if (this.webAccessForm.valid) {
      this.webAccessForm.disable();
      if (this.webAccessForm.value.userName !== this.userName) {
        this.$toast.error('User Name is wrong');
        this.webAccessForm.controls['userName'].setErrors({
          'wrong': true
        })
        this.webAccessForm.controls['userName'].reset();
        this.webAccessForm.enable();
        return;
      }
      if (this.webAccessForm.controls.password.value !== this.secretPassword) {
        this.webAccessForm.controls['password'].setErrors({
          'wrong': true
        })
        this.$toast.error('Password is wrong')
        this.webAccessForm.controls['password'].reset();
        // this.webAccessForm.updateValueAndValidity();
        this.webAccessForm.enable();
        return;
      }
      this.$common.setDataInLocalStorage('webAccess', { ...this.webAccessForm.value });
      this.$dialogRef.close({ ...this.webAccessForm.value });
    }
  }

}
